// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styling */
.dashboard-container {
    display: flex;
    flex-direction: column;
    padding: 20px;
    font-family: Arial, sans-serif;
    /* background-color: #f8f9fc; */
  }
  
  .dashboard-header {
    text-align: center;
    margin-bottom: 20px;
    color: #4e73df;
  }
  .dashboard-container .button-group .btn-primary { padding: 8px 15px; }
  .docugnut-section canvas { width: 220px !important; height: 220px !important; margin: 0 auto; }
  
  .metrics-container {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    margin-bottom: 20px;
  }
  
  .metric-card {
    background: #ffffff;
    border: 1px solid #e3e6f0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    flex: 1 1;
    padding: 15px;
    text-align: center;
    font-size: 14px;
    color: #4e73df;
  }
  
  .button-group {
    display: flex;
    justify-content: end;
    gap: 10px;
    margin-bottom: 20px;
  }
  
  .dashboard-button {
    padding: 10px 20px;
    background-color: #4e73df;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
  }
  
  .dashboard-button:hover {
    background-color: #375a7f;
  }
  
  .graphs-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
  
  .graph-card {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 20px);
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 15px;
    text-align: center;
  }
  
  .graph-card h3 {
    margin-bottom: 10px;
    color: var(--primary_color);
    font-size: 16px;
  }

  .metric-card p {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    color: var(--text_color);
}
.metric-card p strong {
  font-size: 16px;
  font-weight: 700;
  color: var(--black_color);
}
  

 /* Responsive Design */
 @media (max-width: 991px) {
 
  .button-group {
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

  .dashboard-button {
    width: 100%;
  }
  .my-body-class .main-content {
    padding: 70px 0px 0px !important;
}

}
  /* Responsive Design */
  @media (max-width: 767px) {
    .metrics-container {
      flex-direction: column;
    }
  
    .graphs-container {
      flex-direction: column;
    }
  
    .button-group {
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
  }
  
    .dashboard-button {
      width: 100%;
    }

    .my-body-class .main-content {
      padding: 50px 0px 0px !important;
  }
  
  
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/BotManage/Dashboard.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;EAChB;EACA,kDAAkD,iBAAiB,EAAE;EACrE,2BAA2B,uBAAuB,EAAE,wBAAwB,EAAE,cAAc,EAAE;;EAE9F;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;IACxC,kBAAkB;IAClB,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA;IACE,YAA8B;IAA9B,cAA8B;IAA9B,gCAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;;CAGC,sBAAsB;CACtB;;EAEC;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;EAEE;IACE,WAAW;EACb;EACA;IACE,gCAAgC;AACpC;;AAEA;EACE,sBAAsB;EACtB;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,eAAe;MACf,mBAAmB;MACnB,uBAAuB;EAC3B;;IAEE;MACE,WAAW;IACb;;IAEA;MACE,gCAAgC;EACpC;;;EAGA","sourcesContent":["/* General Styling */\n.dashboard-container {\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    font-family: Arial, sans-serif;\n    /* background-color: #f8f9fc; */\n  }\n  \n  .dashboard-header {\n    text-align: center;\n    margin-bottom: 20px;\n    color: #4e73df;\n  }\n  .dashboard-container .button-group .btn-primary { padding: 8px 15px; }\n  .docugnut-section canvas { width: 220px !important; height: 220px !important; margin: 0 auto; }\n  \n  .metrics-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 15px;\n    margin-bottom: 20px;\n  }\n  \n  .metric-card {\n    background: #ffffff;\n    border: 1px solid #e3e6f0;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    flex: 1;\n    padding: 15px;\n    text-align: center;\n    font-size: 14px;\n    color: #4e73df;\n  }\n  \n  .button-group {\n    display: flex;\n    justify-content: end;\n    gap: 10px;\n    margin-bottom: 20px;\n  }\n  \n  .dashboard-button {\n    padding: 10px 20px;\n    background-color: #4e73df;\n    color: #ffffff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s;\n  }\n  \n  .dashboard-button:hover {\n    background-color: #375a7f;\n  }\n  \n  .graphs-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n  }\n  \n  .graph-card {\n    flex: 1 1 calc(33.333% - 20px);\n    background: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    padding: 15px;\n    text-align: center;\n  }\n  \n  .graph-card h3 {\n    margin-bottom: 10px;\n    color: var(--primary_color);\n    font-size: 16px;\n  }\n\n  .metric-card p {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 400;\n    color: var(--text_color);\n}\n.metric-card p strong {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--black_color);\n}\n  \n\n /* Responsive Design */\n @media (max-width: 991px) {\n \n  .button-group {\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n}\n\n  .dashboard-button {\n    width: 100%;\n  }\n  .my-body-class .main-content {\n    padding: 70px 0px 0px !important;\n}\n\n}\n  /* Responsive Design */\n  @media (max-width: 767px) {\n    .metrics-container {\n      flex-direction: column;\n    }\n  \n    .graphs-container {\n      flex-direction: column;\n    }\n  \n    .button-group {\n      flex-wrap: wrap;\n      align-items: center;\n      justify-content: center;\n  }\n  \n    .dashboard-button {\n      width: 100%;\n    }\n\n    .my-body-class .main-content {\n      padding: 50px 0px 0px !important;\n  }\n  \n  \n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
